'use strict';
import { isIE, isiOs } from './plugins/browser-checks';


// global requires / imports
window.Cookies = require('js-cookie');


window.viewport = function() {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}


window.removeCookie = function (cookie) {
    Cookies.remove(cookie);
};

window.setCookie = function (cookie, value, expires) {
    Cookies.set(cookie, value, { expires: expires });
};


jQuery(() => {
    // global functionality goes here
    const $body = $('body'),
        $masthead = $('header.masthead');

    if(isIE()) {
        $body.addClass('browser-ie');
    }

    if(isiOs()) {
        $body.addClass('browser-ios');
    }


    // prevent disabled buttons to execute default actions
    $('.btn--disabled').on('click', function(e) {
        e.preventDefault();
    });


    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').hide();
    }

    // load extra JS parts
    require('./modules/gravity-forms');
    require('./modules/gtm-events');
    require('./modules/smooth-scroll-to');
    require('./modules/sliders');
    require('./modules/background-video');
    require('./modules/anchors-missing-title');
    require('./modules/insert-icons');
    require('./modules/quantity-orbs');
    require('./modules/modify-page-title');
    require('./modules/scroll-events');
    require('./modules/fancy-video');
    require('./modules/leaflet-maps');
    require('./modules/logo-addons');
    require('./modules/eggs');
    require('./modules/expandable-items');
    require('./modules/wizard');
    require('./modules/truedark');
    require('./modules/lynkco');
    require('./modules/site-loader');
    require('./modules/key-visual');
    require('./modules/masthead');
    require('./modules/menu');
    require('./modules/mobile-menu');
    require('./modules/footer');

});
